/**
 * @file 所有挂载到 Vue.prototype上的公共函数
 */

import * as constants from '@/tools/constants.js';

import * as tools from '@/tools/tools.js';

import axios from 'axios';


const instance = axios.create();


export default {
	nextTickFn(that) {
		return new Promise(resFn => {
			that.$nextTick(() => {
				resFn();
			})
		})
	},

	// 封装网络请求
	['$fetch'](options) {
		const that = this;

		let {
			method, // 请求方式 {String}
			temUrl, // 临时的请求地址 一般用来调试 一般用不到
			url, // 请求地址 {String}
			data, // 请求数据 {Object}
			params, // 请求数据 {Object}
			headers, // 请求头 {Object}

			resultDataType, // 返回数据格式默认 Object,

			handleErrFn
		} = options;

		method = method ? method : 'get';
		method = `${method}`.toUpperCase();

		resultDataType = resultDataType ? resultDataType : 'Object';


		handleErrFn = handleErrFn ? handleErrFn : ({
			msg
		}) => {
			// console.log('handleErrFn run', msg);
			that.$message.error(`${msg}`);
		}

		// 处理可能调试使用的 临时网络地址
		if (temUrl) {
			// 有临时的请求地址 就 用 临时的请求地址
			url = temUrl;
		} else {
			// 否则用默认的 host + url
			const host = that.getHostFn();

			url = `${host}${url}`;
		}



		const headerObject = {};
		if (that.checkLoginFn()) {
			headerObject.token = that.getClientTokenFn();
		}
		return new Promise(async resFn => {
			try {
				const result = await instance({
					timeout: 1000 * 60, // 请求超过60s 自动断开
					method,
					url,
					headers: {
						...headerObject,
						...headers
					},
					params,
					data: {
						...data,
						// token: that.getClientTokenFn()
					},
				});
				console.log('$fetch await axios result', {
					instance,
					result
				});

				const code = tools.objectGet(result, 'data.code');
				const msg = tools.objectGet(result, 'data.msg') || result.status;


				if (code == 200) {
					const resultObject = {
						code,
						msg,
						networkStatus: constants.networkEnum.networkSuccess,
						time: tools.objectGet(result, 'data.time'),
						data: tools.objectGet(result, 'data.data'),
					};
					if (resultDataType == 'Object') {
						resultObject.data = tools.objectGetObject(result, 'data.data');
					} else if (resultDataType == 'Array') {
						resultObject.data = tools.objectGetArray(result, 'data.data');
					}
					resFn(resultObject);
				} else if (code == 40011) {

					console.log('40011 e');

					if (!that.$store.state.errorMsgFlag) {

						that.$store.commit('setStateDataFn', {
							errorMsgFlag: true
						});

						that.$alert(msg, '提示', {
							lockScroll: false,
							closeOnClickModal: true,
							confirmButtonText: '确定',
							callback: e => {
								console.log('this.$alert callback e', e);

								that.$store.commit('setStateDataFn', {
									errorMsgFlag: false
								});

								localStorage.setItem('token', '');
								that.$store.commit('setStateDataFn', {
									token: ''
								});

								if (that.$route.path == '/') {
									location.reload();
								} else {
									that.$router.replace({
										path: `/`
									});
								}
							}
						});

					}


				} else {
					const resultObject = {
						networkStatus: constants.networkEnum.networkError,
						msg,
						result
					};
					handleErrFn(resultObject)
					resFn(resultObject);
				}
			} catch (e) {
				console.log('$fetch await axios catch e', e);
				const resultObject = {
					networkStatus: constants.networkEnum.networkError,
					msg: e.message,
					result: e
				};
				handleErrFn(resultObject);
				resFn(resultObject);
			}
		});
	},


	// 判断网络请求 是否成功; 成功返回true, 失败返回false
	checkNetworkSuccessFn(result) {
		if (tools.objectGet(result, 'networkStatus') === constants.networkEnum.networkSuccess) {
			return true;
		}
		return false;
	},

	// 判断数据是否正常; 成功返回true, 失败返回false
	checkResultDatasFn(result) {
		if (tools.objectGet(result, 'networkStatus') != constants.networkEnum.networkError) {
			return true;
		}
		return false;
	},

	// 从客户端本地获取token并返回
	getClientTokenFn() {
		const token = this.$store.state.token; // vuex全局状态管理里取
		return token ? token : localStorage.getItem('token'); // 全局状态里没有再返回localStorage
	},
	// 判断用户是否登录
	checkLoginFn() {
		if (this.getClientTokenFn()) {
			return true;
		}
		return false;
	},

	// 获取当前域名
	getHostFn() {
		const host = this.$store.state.host;
		return host ? host : tools.assertString(localStorage.getItem('host'));
	},






	// 判断数据是否正常
	checkDataSuccessfulFn(result) {
		return !tools.objectGet(result, 'disableData');
	},
	// 判断网络请求是否正常
	checkApiSuccessfulFn(result) {
		const isSuccess = tools.objectGet(result, 'code') == 200;
		if (!isSuccess) {
			if (tools.checkTypeFn(result) == 'Object') {
				result.disableData = true;
			}
			const msg = tools.objectGetString(result, 'msg')
			if (msg) {
				this.$message.error(msg);
			}
		}
		return isSuccess;
	},


	setDatasFn(that, data) {
		Object.keys(data).forEach(key => {
			that[key] = data[key];
		});
	},
	// 停止3秒钟
	sleepFn(time = 3) {
		console.log(`sleepFn 阻止程序${time}秒`);
		return new Promise((resFn) => {
			setTimeout(() => {
				resFn(`sleepFn 阻塞完毕${time}秒`);
			}, time * 1000);
		});
	},


	// 返回保留两位小数的字符串类型数字
	transDoubleNumStr(number, n = 2) {
		return tools.toDoubleNumFn(tools.transNumFn(number), n);
	},



};


// WEBPACK FOOTER //
// ./src/tools/mixinMethods.js